// @flow
import { Map } from "immutable"

import type { Action } from "./actions"
import type { State } from "booking/services/types"

export type Advices = ?Map

const DEFAULT_STATE: Advices = new Map()

const advicesReducer = (state: Advices = DEFAULT_STATE, action: Action): Advices => {
  switch (action.type) {
    case "SET_ADVICES":
      return action.payload
    default:
      return state
  }
}

export default advicesReducer

// Data selectors
// ===
export const getAdvices = (state: State) => state.reservation.advices
